import { memo } from "react";

import type { MFASettingsType } from "@/hooks/use-auth-client/use-mfa-settings";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { MfaToggleControls } from "./mfa-field";
import { MfaInformation } from "./mfa-information";

type Props = {
	mfaSettings: MFASettingsType;
	onSettingsChange: (newSettings: MFASettingsType) => void;
};

export const IslandMfaSettings = memo(({ mfaSettings, onSettingsChange }: Props) => {
	return (
		<FeatureIslandMainWithBackGround islandTitle="２段階認証">
			<div className="flex flex-col gap-y-12">
				<MfaInformation />
				<MfaToggleControls mfaSettings={mfaSettings} onSettingsChange={onSettingsChange} />
			</div>
		</FeatureIslandMainWithBackGround>
	);
});

IslandMfaSettings.displayName = "IslandMfaSettings";
